// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#formula_row {
  cursor: pointer;
}

#listing_table_date {
  min-width: 140px;
  width: 4%;
}

#listing_table_doctor {
  min-width: 290px;
  width: 16%;
}

.listing_table-notes {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientDetailsPageDentalFormList/PatientDetailsPageDentalFormList.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,gBAAA;EACA,SAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,UAAA;AAGJ;;AADA;EACI,gBAAA;AAIJ","sourcesContent":["#formula_row {\r\n    cursor: pointer;\r\n}\r\n#listing_table_date {\r\n    min-width: 140px;\r\n    width: 4%;\r\n}\r\n#listing_table_doctor {\r\n    min-width: 290px;\r\n    width: 16%;\r\n}\r\n.listing_table-notes {\r\n    text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
